module.exports = __webpack_public_path__ + "img/switzerland-leukaemia-male.b40e17bc.png";